module.exports = __webpack_public_path__ + "img/ap2020-result-logo.b2ea152.png";